import { Route, Routes } from "react-router-dom";
import BookList from "./shared/Component/BookList/BookList";
import BookDetailPage from "./shared/Component/BookDetailPage/BookDetailPage";
import TeamMeeting from "./pages/TeamsIntegration";
import ViewMeetingDetails from "./pages/ViewMeeting";
import Gallery from "./shared/Component/BackOffice/Gallery/Gallery";
import GalleryEdit from "./shared/Component/BackOffice/Gallery/GalleryEdit";
import TestBatchUpdate from "./shared/Component/BackOffice/TestBatchUpdate/TestBatchUpdate";
import TestBatchUpdateEdit from "./shared/Component/BackOffice/TestBatchUpdate/TestBatchUpdateEdit";
import BranchLocation from "./shared/Component/BackOffice/BranchLocation/BranchLocation";
import BranchLocationEdit from "./shared/Component/BackOffice/BranchLocation/BranchLocationEdit";
import ViewTestCourseBatch from "./shared/Component/BackOffice/TestCourseBatch/TestCourseBatch";
import CreateTestCourseBatch from "./shared/Component/BackOffice/TestCourseBatch/CreateTestCourseBatch";
import Degree from "./shared/Component/BackOffice/Degree/Degree";
import DegreeEdit from "./shared/Component/BackOffice/Degree/DegreeEdit";
import AddToCardTemplate from "./shared/Component/Card/AddToCardTemplate";
import ForgetPassword from "./pages/ForgetPassword";
import Resetpassword from "./shared/Component/Resetpassword/Resetpassword";
import NewPassword from "./shared/Component/NewPassword/NewPassword";
import RegisterSuccess from "./shared/Component/Registersuccess/Registersuccess";
import Register from "./shared/Component/Register/Register";
import Login from "./shared/Component/Login/Login";
import EmailReset from "./pages/ResetPasswordEmail";
import SampleForm from "./pages/SampleForm";
import IndexPage from "./pages/dashboard/IndexPage";
import ViewBook from "./shared/Component/BackOffice/BookModule/ViewBook/ViewBook";
import ViewAllBookPage from "./shared/Component/BackOffice/BookModule/ViewBook/ViewAllBookPage";
import StudyMaterial from "./shared/Component/BackOffice/BookModule/HomePage/StudyMaterial";
import GridImageAdminInfo from "./shared/Component/BackOffice/TestAdminWorkflow/Gallery/AdminImage/GridImageAdminInfo";
import GridVideoAdminInfo from "./shared/Component/BackOffice/TestAdminWorkflow/Gallery/AdminVideo/GridVideoAdminInfo";
import ViewImageAdminInfo from "./shared/Component/BackOffice/TestAdminWorkflow/Gallery/AdminImage/ViewImageAdminInfo";
import ViewVideoAdminInfo from "./shared/Component/BackOffice/TestAdminWorkflow/Gallery/AdminVideo/ViewVideoAdminInfo";
import CourseContent from "./shared/Component/BackOffice/StudentTestWorkflow/CourseContent/CourseContent";
import PdfPreviewPage from "./shared/Component/PdfPreviewPage";
import HomeFull from "./shared/Component/BackOffice/StudentTestWorkflow/HomeFull";
import EmailVerfiy from "./shared/Component/OtpScreen/EmailVerfiy";
import PhoneNumberVerify from "./shared/Component/OtpScreen/PhoneNumberVerify";
import Dashboard from "./pages/dashboard/Dashboard";
import JoinTestScreen from "./shared/Component/BackOffice/StudentTestWorkflow/JoinTestScreen";
import AdmissionForm from "./pages/AdmissionForm";
import TestBatchView from "./shared/Component/BackOffice/CourseBatch/TestBatchView";
import SpecialClass from "./pages/SpecialClass";
import TestBatch from "./pages/TestBatch";
import ModelExamForm from "./shared/Component/ModelExam/ModelExamForm";
import MockInterview from "./shared/Component/MockInterview/MockInterview";
import Counselling from "./shared/Component/Counselling/Counselling";
import ReviewCouresAdmission from "./pages/ReviewCouresAdmission";
import ReviewTestAdmission from "./pages/ReviewTestAdmission";
import ReviewSpecialAdmission from "./pages/ReviewSpecialAdmission";
import ReviewModelexam from "./shared/Component/ModelExam/ReviewModelexam";
import ReviewMockInterviewAdm from "./shared/Component/MockInterview/ReviewMockInterviewAdm";
import ReviewCounselling from "./shared/Component/Counselling/ReviewCounselling";
import ProfileSetting from "./pages/dashboard/ProfileSetting";
import InvoiceTemplate from "./pages/InvoiceTemplate";
import AddToCart from "./shared/Component/BackOffice/BookModule/AddToCart/AddToCart";
import CartSuccess from "./shared/Component/BackOffice/BookModule/AddToCart/CartSuccess";
import Wishlist from "./shared/Component/BackOffice/BookModule/HomePage/Wishlist";
import ViewTopTestPerformerAnswerSheet from "./shared/Component/BackOffice/StudentTestWorkflow/StudentDescriptive/ViewTopTestPerformerAnswerSheet";
import ViewTestPerfomance from "./shared/Component/BackOffice/StudentTestWorkflow/pages/ViewTestPerfomance";
import PurchaseListview from "./shared/Component/BackOffice/Purchase/PurchaseListview";
import PaymentSuccess from "./shared/Component/BackOffice/StudentTestWorkflow/PaymentSuccess";
import ReadViewAdmissionHistory from "./shared/Component/BackOffice/Purchase/ReadViewAdmissionHistory";
import PaymentHistory from "./shared/Component/BackOffice/Purchase/PaymentHistory";
import ViewSchedule from "./shared/Component/BackOffice/Purchase/ViewSchdule";
import TestPerformanceTablist from "./shared/Component/BackOffice/StudentTestWorkflow/TestPerformanceTablist";
import JoinTest from "./shared/Component/BackOffice/StudentTestWorkflow/pages/JoinTest";
import QuestionList from "./shared/Component/BackOffice/question/QuestionList";
import ReviewSub from "./shared/Component/BackOffice/StudentTestWorkflow/ReviewSub";
import TestPerformance from "./shared/Component/BackOffice/StudentTestWorkflow/TestPerformance";
import ViewTestDetail from "./shared/Component/BackOffice/StudentTestWorkflow/ViewTestDetail";
import TestViewSchedule from "./shared/Component/BackOffice/StudentTestWorkflow/TestViewSchedule";
import PayFee from "./pages/PayFee";
import StudentProfile from "./shared/Component/BackOffice/StudentTestWorkflow/StudentCouponCode/StudentProfile";
import EditProfile from "./shared/Component/BackOffice/StudentTestWorkflow/StudentCouponCode/EditProfile";
import StudentCouponCode from "./shared/Component/BackOffice/StudentTestWorkflow/StudentCouponCode/StudentCouponCode";
import StudentRewardPoints from "./shared/Component/BackOffice/StudentTestWorkflow/StudentCouponCode/StudentRewardPoints";
import DownloadHallTicket from "./shared/Component/ModelExam/DownloadHallTicket";
import StudentsList from "./shared/Component/BackOffice/Faculty/StudentsList/StudentsList";
import ViewStudent from "./shared/Component/BackOffice/Faculty/StudentsList/ViewStudent";
import UpdateMarks from "./shared/Component/BackOffice/Faculty/StudentsList/UpdateMarks";
import StudentsQuery from "./shared/Component/BackOffice/Faculty/StudentsQuery/StudentsQuery";
import UploadMarkSheet from "./shared/Component/BackOffice/ModelExamBatch/UploadMarkSheet";
import ModelExamAnalytics from "./shared/Component/BackOffice/ModelExamBatch/ModelExamAnalytics";
import CreatePreOrder from "./shared/Component/BackOffice/BookModule/AdminSide/BookTabs/PreOrder/CreatePreOrder";
import ViewPreOrder from "./shared/Component/BackOffice/BookModule/AdminSide/BookTabs/PreOrder/ViewPreOrder";
import ListReview from "./shared/Component/BackOffice/BookModule/AdminSide/ReviewRating/ListReview";
import ViewReview from "./shared/Component/BackOffice/BookModule/AdminSide/ReviewRating/ViewReview";
import EditReview from "./shared/Component/BackOffice/BookModule/AdminSide/ReviewRating/EditReview";
import CreateBookSet from "./shared/Component/BackOffice/BookModule/AdminSide/BookTabs/BookSet/CreateBookSet";
import ViewBookSet from "./shared/Component/BackOffice/BookModule/AdminSide/BookTabs/BookSet/ViewBookSet";
import EditPreOrder from "./shared/Component/BackOffice/BookModule/AdminSide/BookTabs/PreOrder/EditPreOrder";
import BookTab from "./shared/Component/BackOffice/BookModule/AdminSide/BookTabs/BookTab";
import IndividualBookInfoCreate from "./shared/Component/BackOffice/BookModule/AdminSide/BookTabs/IndividualBook/IndividualBookInfoCreate";
import ViewIndividualBook from "./shared/Component/BackOffice/BookModule/AdminSide/BookTabs/IndividualBook/ViewIndividualBook";
import ListviewBatch from "./shared/Component/BackOffice/CourseBatch/ListviewBatch";
import ReadViewBath from "./shared/Component/BackOffice/CourseBatch/ReadViewBath";
import CentreSupervisor from "./shared/Component/BackOffice/CentreSupervisors/CentreSupervisor";
import ViewModelExamAnalytics from "./shared/Component/BackOffice/ModelExamBatch/ViewModelExamAnalytics";
import ExamCentreByDistrict from "./shared/Component/BackOffice/CourseBatch/ExamCentreByDistrict";
import CreateCourseBatch from "./shared/Component/BackOffice/CourseBatch/CreateCourseBatch";
import Listview from "./shared/Component/StudentConfirm/Listview";
import StudentConfirm from "./shared/Component/StudentConfirm/StudentConfirm";
import CreateEvent from "./shared/Component/BackOffice/Event/CreateEvent";
import NewFaculty from "./shared/Component/BackOffice/Faculty/NewFaculty";
import ReadFaculty from "./shared/Component/BackOffice/Faculty/ReadFaculty";
import ReviewFaculty from "./shared/Component/BackOffice/Faculty/ReviewFaculty";
import ListViewFaculty from "./shared/Component/BackOffice/Faculty/ListViewFaculty";
import ModelExamCenter from "./shared/Component/BackOffice/ModelExamBatch/ModelExamCenter";
import ViewModelExam from "./shared/Component/BackOffice/ModelExamBatch/ViewModelExam";
import AddPanelMember from "./shared/Component/BackOffice/Faculty/AddPanelMember";
import ReadViewPMem from "./shared/Component/BackOffice/Faculty/ReadViewPMem";
import FacultyDetailview from "./shared/Component/BackOffice/Faculty/FacultyDetailview";
import NonFDetailview from "./shared/Component/BackOffice/Faculty/NonFDetailview";
import AddSalary from "./shared/Component/BackOffice/Faculty/AddSalary";
import ReadViewSalary from "./shared/Component/BackOffice/Faculty/ReadViewSalary";
import PanelMemberView from "./shared/Component/BackOffice/Faculty/PanelMemberView";
import FacultyProfile from "./shared/Component/BackOffice/Faculty/FacultyProfile";
import AdminViewAnswerSheet from "./shared/Component/BackOffice/TestAdminWorkflow/Descriptive/TopPerfomanceAnswerSheet/AdminViewAnswerSheet/AdminViewAnswerSheet";
import TopPerfomanceAnswerSheet from "./shared/Component/BackOffice/TestAdminWorkflow/Descriptive/TopPerfomanceAnswerSheet/TopPerfomanceAnswerSheet";
import AdminViewStudent from "./shared/Component/BackOffice/TestAdminWorkflow/Descriptive/AdminViewStudent/AdminViewStudent";
import ViewTestList from "./shared/Component/BackOffice/TestAdminWorkflow/Descriptive/ViewTestList";
import UploadAnswerSheet from "./shared/Component/BackOffice/TestAdminWorkflow/Descriptive/UploadAnswerSheet/UploadAnswerSheet";
import ViewEvaluator from "./shared/Component/BackOffice/TestAdminWorkflow/Descriptive/ViewEvaluator";
import SubjectInfoCreate from "./shared/Component/BackOffice/CourseInfo/Subjects/SubjectInfoCreate";
import TestTopicInfoCreate from "./shared/Component/BackOffice/CourseInfo/TestTopics/TestTopicInfoCreate";
import NonFacultyProfile from "./shared/Component/BackOffice/Faculty/NonFacultyProfile";
import AddImageAdminInfo from "./shared/Component/BackOffice/TestAdminWorkflow/Gallery/AdminImage/AddImageAdminInfo";
import AddVideoAdminInfo from "./shared/Component/BackOffice/TestAdminWorkflow/Gallery/AdminVideo/AddVideoAdminInfo";
import AddFolderAdminInfo from "./shared/Component/BackOffice/TestAdminWorkflow/Gallery/AdminFolder/AddFolderAdminInfo";
import ViewBannerAdminInfo from "./shared/Component/BackOffice/TestAdminWorkflow/Gallery/Banner/ViewBannerAdminInfo";
import AddBannerAdminInfo from "./shared/Component/BackOffice/TestAdminWorkflow/Gallery/Banner/AddBannerAdminInfo";
import DSchedule from "./shared/Component/BackOffice/CourseBatch/DSchedule";
import ViewQuestionPaper from "./shared/Component/BackOffice/TestAdminWorkflow/ViewQuestionPaper";
import FaculityView from "./shared/Component/BackOffice/Faculty/normalFaculity/FaculityView";
import TestListview from "./shared/Component/BackOffice/TestAdminWorkflow/TestListview";
import ReviewUserDetail from "./shared/Component/BackOffice/RegsisteredUser/ReviewUserDetail";
import UploadQuestionFile from "./shared/Component/BackOffice/TestAdminWorkflow/UploadQuestionFile";
import UserList from "./shared/Component/BackOffice/RegsisteredUser/UserList";
import GenarateReportListView from "./shared/Component/BackOffice/GenerateReport/GenarateReportListView";
import ListAnnouncementInfo from "./shared/Component/BackOffice/Announcements/ListAnnouncementInfo";
import ListCouponCode from "./shared/Component/BackOffice/CouponCode/ListCouponCode";
import CouponInfoCreate from "./shared/Component/BackOffice/CouponCode/ViewCouponCode/CouponInfoCreate";
import ViewCouponCode from "./shared/Component/BackOffice/CouponCode/ViewCouponCode/ViewCouponCode";
import CourseInfoCreate from "./shared/Component/BackOffice/CourseInfo/Course/CourseInfoCreate";
import CourseManagement from "./shared/Component/BackOffice/CourseInfo/CourseManagement";
import ViewCourseInfo from "./shared/Component/BackOffice/CourseInfo/Course/ViewCourseInfo";
import ViewSubjectInfo from "./shared/Component/BackOffice/CourseInfo/Subjects/ViewSubjectnfo";
import ViewTestTopicInfo from "./shared/Component/BackOffice/CourseInfo/TestTopics/ViewTestTopicInfo";
import CreateAnnouncementInfo from "./shared/Component/BackOffice/Announcements/CreateAnnouncementInfo";
import ViewAnnouncementInfo from "./shared/Component/BackOffice/Announcements/ViewAnnouncementInfo";
import PurchsaeInfoCreate from "./shared/Component/BackOffice/BookModule/AdminSide/Purchase/PurchaseInfoCreate";
import ListPurchase from "./shared/Component/BackOffice/BookModule/AdminSide/Purchase/ListPurchase";
import ViewPurchase from "./shared/Component/BackOffice/BookModule/AdminSide/Purchase/ViewPurchase/ViewPurchase";
import AddNewCourierDetails from "./shared/Component/BackOffice/BookModule/AdminSide/Purchase/ViewPurchase/AddNewCourierDetails";
import ViewCourierDetails from "./shared/Component/BackOffice/BookModule/AdminSide/Purchase/ViewPurchase/ViewCourierDetails";
import ListCouierCharges from "./shared/Component/BackOffice/CourierCharges/ListCourierCharges";
import ViewCouierCharges from "./shared/Component/BackOffice/CourierCharges/ViewCourierCharges";
import CreateCourierCharges from "./shared/Component/BackOffice/CourierCharges/CreateCourier";
import EditCourierCharges from "./shared/Component/BackOffice/CourierCharges/EditCourierCharges";
import ListRewardPoints from "./shared/Component/BackOffice/BookModule/AdminSide/RewardPoints/ListRewardPoints";
import CreateRewardPoints from "./shared/Component/BackOffice/BookModule/AdminSide/RewardPoints/CreateRewardPoints";
import ViewRewardPoints from "./shared/Component/BackOffice/BookModule/AdminSide/RewardPoints/ViewRewardPoints";
import RoleList from "./pages/dashboard/RBAC/RolesList";
import MenuList from "./pages/dashboard/RBAC/MenuList";
import CashListView from "./shared/Component/BackOffice/Cashpayment/CashListView";
import CashPayFee from "./shared/Component/BackOffice/Cashpayment/CashPayFee";
import ViewStudentQuery from "./shared/Component/BackOffice/Faculty/StudentsQuery/ViewStudentQuery";
import ViewRole from "./pages/dashboard/RBAC/ViewRole";
import EditPage from "./pages/dashboard/RBAC/EditPage";
import DetailTestView from "./shared/Component/BackOffice/TestAdminWorkflow/DetailTestView";
import ClassList from "./shared/Component/BackOffice/TestAdminWorkflow/ClassList";
import ClassPerformanceTablist from "./shared/Component/BackOffice/StudentTestWorkflow/ClassPerformanceTablist";
import TermsConditionBook from "./shared/Component/TermsCondition/TermsConditionBook";
import TermsCondition from "./shared/Component/TermsCondition/TermsCondition";
import ContactUs from "./shared/Component/ContactAs/ContactUs";
import ViewEventDetails from "./shared/Component/BackOffice/StudentTestWorkflow/ViewEventDetails";
import StaffDetailCalendar from "./shared/Component/BackOffice/Faculty/StaffDetailCalendar";
import ShippingPolicy from "./shared/Component/TermsCondition/ShippingPolicy";
import RefundPolicy from "./shared/Component/TermsCondition/RefundPolicy";
import PrivacyPolicy from "./shared/Component/TermsCondition/PrivacyPolicy";
import ReviewTProgress from "./shared/Component/BackOffice/Faculty/ReviewTProgress";
import ListInterviewDetails from "./shared/Component/BackOffice/CourseBatch/MockInterviewDetails/ListInterviewDetails";
import PanelInfoCreate from "./shared/Component/BackOffice/CourseBatch/PanelDetails/PanelInfoCreate";
import ViewPanelInfo from "./shared/Component/BackOffice/CourseBatch/PanelDetails/ViewPanelDetails";
import ListPanelInfo from "./shared/Component/BackOffice/CourseBatch/PanelDetails/PanelList";
import ViewInterviewDetails from "./shared/Component/BackOffice/CourseBatch/MockInterviewDetails/ViewInterviewDetails";
import ViewStudentDetails from "./shared/Component/BackOffice/CourseBatch/StudentDetails/ViewStudentDetails";
import FeedbackList from "./shared/Component/BackOffice/CourseBatch/StudentFeedback/FeedbackList";
import ViewInterviewPerfomance from "./shared/Component/BackOffice/CourseBatch/StudentFeedback/ViewInterviewPerfomance";
import MockInterviewMarksUpdate from "./shared/Component/BackOffice/CourseBatch/PanelDetails/MockInterviewMarksUpdate";
import InterviewFeedBackList from "./shared/Component/BackOffice/CourseBatch/PanelDetails/InterviewFeedBackList";
import ViewInterviewJoin from "./shared/Component/BackOffice/CourseBatch/StudentFeedback/ViewInterviewJoin";
import WhoWeAre from "./pages/staticpages/WhoWeAre";
import WhyChooseUs from "./pages/staticpages/WhyChooseUs";
export const guestRoutes = [
  { id: "G1", path: "/forgetPassword", element: <ForgetPassword /> },
  { id: "G2", path: "/pwdmail/:email", element: <Resetpassword /> },
  { id: "G3", path: "/newpassword/:id", element: <NewPassword /> },
  { id: "G4", path: "/resetpwd", element: <Resetpassword /> },
  { id: "G5", path: "/registersuccess", element: <RegisterSuccess /> },
  { id: "G6", path: "/viewformapp", element: <Register /> },
  { id: "G7", path: "/register", element: <Login /> },
  { id: "G8", path: "/resetemail", element: <EmailReset /> },
  { id: "G9", path: "login", element: <SampleForm /> },
  { id: "G10", path: "/RegisterUser/EmailVerify", element: <EmailVerfiy /> },
  {
    id: "G11",
    path: "/RegisterUser/PhoneNumberVerify",
    element: <PhoneNumberVerify />,
  },
  { id: "G12", path: "/preview", element: <PdfPreviewPage /> },
  {
    id: "G13",
    path: "/",
    element: <Dashboard />,
    children: [
      { id: "G14", path: "/preview", element: <PdfPreviewPage /> },
      { id: "G15", path: "/booklist", element: <BookList /> },
      { id: "G16", path: "products/:id", element: <BookDetailPage /> },
      { id: "G17", path: "/Teams", element: <TeamMeeting /> },
      { id: "G18", path: "/view", element: <ViewMeetingDetails /> },
      { id: "G19", path: "/gallery", element: <Gallery /> },
      { id: "G20", path: "/galleryedit", element: <GalleryEdit /> },
      { id: "G21", path: "/testbatch", element: <TestBatchUpdate /> },
      { id: "G22", path: "/testbatchedit", element: <TestBatchUpdateEdit /> },
      { id: "G23", path: "/branch", element: <BranchLocation /> },
      { id: "G24", path: "/branchedit", element: <BranchLocationEdit /> },
      { id: "G25", path: "/branchedit/:id", element: <BranchLocationEdit /> },
      {
        id: "G26",
        path: "/ViewTestcoursebatch",
        element: <ViewTestCourseBatch />,
      },
      {
        id: "G27",
        path: "/createTestcoursebatch",
        element: <CreateTestCourseBatch />,
      },
      {
        id: "G28",
        path: "/createTestcoursebatch/:id",
        element: <CreateTestCourseBatch />,
      },
      { id: "G29", path: "/ViewDegree", element: <Degree /> },
      { id: "G30", path: "/createDegree", element: <DegreeEdit /> },
      { id: "G31", path: "/createDegree/:id", element: <DegreeEdit /> },
      { id: "G32", path: "/add_to_cart", element: <AddToCardTemplate /> },
      { id: "G33", path: "/HomeFull", element: <HomeFull /> },
      { id: "G34", path: "ViewBook/:id", element: <ViewBook /> },
      {
        id: "G35",
        path: "studyMaterials/Books/ViewAllBook",
        element: <ViewAllBookPage />,
      },
      { id: "G36", path: "StudyMaterial/Books", element: <StudyMaterial /> },
      { id: "G37", path: "/GalleryImages", element: <GridImageAdminInfo /> },
      { id: "G38", path: "/GalleryVideos", element: <GridVideoAdminInfo /> },
      { id: "G39", path: "/ViewImages/:id", element: <ViewImageAdminInfo /> },
      { id: "G40", path: "/ViewVideos/:id", element: <ViewVideoAdminInfo /> },
      {
        id: "G41",
        path: "/CourseContent/:name/:id",
        element: <CourseContent />,
      },
      { id: "G42", index: true, element: <IndexPage /> },
      {
        id: "G43",
        path: "/AdmissionTermsAndCondition",
        element: <TermsCondition />,
      },
      {
        id: "G44",
        path: "/BooksTermsAndCondition",
        element: <TermsConditionBook />,
      },
      {
        id: "G45",
        path: "/ContactUs",
        element: <ContactUs />,
      },
      {
        id: "G46",
        path: "/ShippingPolicy",
        element: <ShippingPolicy />,
      },
      {
        id: "G47",
        path: "/RefundAndCancellationPolicy",
        element: <RefundPolicy />,
      },
      {
        id: "G48",
        path: "/AdmissionPrivacyPolicy",
        element: <PrivacyPolicy />,
      },
      {
        id: "G49",
        path: "/WhoWeAre",
        element: <WhoWeAre />,
      },
      {
        id: "G50",
        path: "/WhyChooseUs",
        element: <WhyChooseUs />,
      },
    ],
  },
];
export const studentRoutes = [
  { id: "S1", path: "/", element: <Dashboard /> },
  { id: "S2", path: "StudyMaterial/Books", element: <StudyMaterial /> },
  {
    id: "S3",
    path: "studyMaterials/Books/ViewAllBook",
    element: <ViewAllBookPage />,
  },
  { id: "S4", path: "ViewBook/:id", element: <ViewBook /> },
  { id: "S5", path: "GalleryImages", element: <GridImageAdminInfo /> },
  { id: "S6", path: "GalleryVideos", element: <GridVideoAdminInfo /> },
  { id: "S7", path: "ViewImages/:id", element: <ViewImageAdminInfo /> },
  { id: "S8", path: "ViewVideos/:id", element: <ViewVideoAdminInfo /> },
  { id: "S9", path: "CourseContent/:name/:id", element: <CourseContent /> },
  { id: "S10", path: "preview", element: <PdfPreviewPage /> },
  { id: "S11", path: "JoinTest", element: <JoinTestScreen /> },
  { id: "S12", path: "Admission/Course", element: <AdmissionForm /> },
  { id: "S13", path: "Admission/TestBatch", element: <TestBatch /> },
  { id: "S14", path: "Admission/SpecialClasses", element: <SpecialClass /> },
  { id: "S15", path: "Admission/Modelexam", element: <ModelExamForm /> },
  { id: "S16", path: "Admission/Mockinterview", element: <MockInterview /> },
  { id: "S17", path: "Admission/Counselling", element: <Counselling /> },
  {
    id: "S18",
    path: "Admission/Course/:edit/:user_id/:admission_id",
    element: <ReviewCouresAdmission />,
  },
  {
    id: "S19",
    path: "Admission/TestBatch/:edit/:user_id/:admission_id",
    element: <ReviewTestAdmission />,
  },
  {
    id: "S20",
    path: "Admission/SpecialClasses/:edit/:user_id/:admission_id",
    element: <ReviewSpecialAdmission />,
  },
  {
    id: "S21",
    path: "Admission/Modelexam/:edit/:user_id/:admission_id",
    element: <ReviewModelexam />,
  },
  {
    id: "S22",
    path: "Admission/Mockinterview/:edit/:user_id/:admission_id",
    element: <ReviewMockInterviewAdm />,
  },
  {
    id: "S23",
    path: "Admission/Counselling/:edit/:user_id/:admission_id",
    element: <ReviewCounselling />,
  },
  { id: "S24", path: "ProfileSetting", element: <ProfileSetting /> },
  { id: "S25", path: "Invoice", element: <InvoiceTemplate /> },
  { id: "S26", path: "AddToCart", element: <AddToCart /> },
  {
    id: "S27",
    path: "AddToCart/PaymentSuccess/:tabLabel",
    element: <CartSuccess />,
  },
  { id: "S28", path: "Wishlist", element: <Wishlist /> },
  {
    id: "S29",
    path: "ViewTopTestPerformerAnswerSheet",
    element: <ViewTopTestPerformerAnswerSheet />,
  },
  { id: "S30", path: "viewTestPerformance", element: <ViewTestPerfomance /> },
  { id: "S31", path: "TransactionHistory", element: <PurchaseListview /> },
  {
    id: "S32",
    path: "TransactionHistory/:active_tab",
    element: <PurchaseListview />,
  },
  {
    id: "S33",
    path: "ViewSchedule/ViewTest/JoinTest",
    element: <PaymentSuccess />,
  },
  {
    id: "S34",
    path: "TransactionHistory/ViewAdmission/:user_id/:batch_id/:add_id/:type/:label",
    element: <ReadViewAdmissionHistory />,
  },
  {
    id: "S35",
    path: "TransactionHistory/ViewAdmission/ViewPaymentHistory/:type/:adm_id",
    element: <PaymentHistory />,
  },
  {
    id: "S36",
    path: "TransactionHistory/ViewAdmission/ViewSchedule/:batch_id/:type",
    element: <ViewSchedule />,
  },
  {
    id: "S37",
    path: "TestPerformanceListView",
    element: <TestPerformanceTablist />,
  },
  {
    id: "S38",
    path: "TestPerformanceListView/:active_tab/:batchIds/:batch_type",
    element: <TestPerformanceTablist />,
  },
  { id: "S39", path: "ViewSchedule/joinTest", element: <JoinTest /> },
  { id: "S40", path: "TestPermeance", element: <QuestionList /> },
  {
    id: "S41",
    path: "ReviewSubmission/:batch_id/:event_id",
    element: <ReviewSub />,
  },
  {
    id: "S42",
    path: "TestPerformance/:batch_id",
    element: <TestPerformance />,
  },
  {
    id: "S43",
    path: "ViewTestDetail/:batch_id/:event_id/:status/:event_type/:type_batch/:labelStatus",
    element: <ViewTestDetail />,
  },
  {
    id: "S44",
    path: "TestViewSchedule/:batch_id/:batch_type",
    element: <TestViewSchedule />,
  },
  { id: "S45", path: "PayFee", element: <PayFee /> },
  { id: "S46", path: "StudentProfile", element: <StudentProfile /> },
  { id: "S47", path: "EditProfile", element: <EditProfile /> },
  { id: "S48", path: "StudentCouponCode", element: <StudentCouponCode /> },
  { id: "S49", path: "StudentRewardPoints", element: <StudentRewardPoints /> },
  { id: "S50", path: "DownloadHallTicket", element: <DownloadHallTicket /> },
  { id: "S51", index: true, element: <IndexPage /> },
  {
    id: "S52",
    path: "/ClassPerformanceListView",
    element: <ClassPerformanceTablist />,
  },
  {
    id: "S53",
    path: "/ClassPerformanceListView/:active_tab/:batchIds/:batch_type",
    element: <ClassPerformanceTablist />,
  },
  {
    id: "S54",
    path: "/AdmissionTermsAndCondition",
    element: <TermsCondition />,
  },
  {
    id: "S55",
    path: "/BooksTermsAndCondition",
    element: <TermsConditionBook />,
  },
  {
    id: "S56",
    path: "/ContactUs",
    element: <ContactUs />,
  },
  {
    id: "S57",
    path: "/ViewEventDetails",
    element: <ViewEventDetails />,
  },

  {
    id: "S58",
    path: "/ShippingPolicy",
    element: <ShippingPolicy />,
  },
  {
    id: "S59",
    path: "/RefundAndCancellationPolicy",
    element: <RefundPolicy />,
  },
  {
    id: "S60",
    path: "/AdmissionPrivacyPolicy",
    element: <PrivacyPolicy />,
  },
  {
    id: "S61",
    path: "/StudentFeedBackList",
    element: <FeedbackList />,
  },
  {
    id: "S62",
    path: "/ViewInterviewPerfomance",
    element: <ViewInterviewPerfomance />,
  },
  {
    id: "S63",
    path: "/ViewInterviewJoin",
    element: <ViewInterviewJoin />,
  },
  {
    id: "S64",
    path: "/WhoWeAre",
    element: <WhoWeAre />,
  },
  {
    id: "S65",
    path: "/WhyChooseUs",
    element: <WhyChooseUs />,
  },
];

export const employeeRoutes = [
  { id: "1", module: "AdminAccess", path: "/", element: <Dashboard /> },
  {
    id: "2",
    module: "AdminAccess",
    path: "/preview",
    element: <PdfPreviewPage />,
  },
  // Study Material
  {
    id: "3",
    mid: "A",
    module: "Study Materials",
    subpage: "Books",
    page: "Books List",
    path: "/studyMaterials/Books/list",
    element: <BookTab />,
    order: "1",
    disable: false,
  },
  {
    id: "3",
    mid: "A",
    subpage: "Books",
    module: "Study Materials",
    page: "Books List",
    path: "/studyMaterials/Books/List/:active_tab",
    element: <BookTab />,
    order: "1",
    disable: false,
  },
  {
    id: "4",
    mid: "A",
    subpage: "Books",
    module: "Study Materials",
    page: "Create New Book",
    path: "/createIndividualBook",
    element: <IndividualBookInfoCreate />,
    order: "2",
    disable: false,
  },

  {
    id: "5",
    mid: "A",
    subpage: "Books",
    module: "Study Materials",
    page: "View Book",
    path: "viewIndividualBook/:id",
    element: <ViewIndividualBook />,
    order: "3",
    disable: false,
  },
  {
    id: "6",
    mid: "A",
    subpage: "Books",
    module: "Study Materials",
    page: "Edit Book",
    path: "createIndividualBook/:id",
    element: <IndividualBookInfoCreate />,
    order: "4",
    disable: false,
  },
  {
    id: "4",
    mid: "A",
    subpage: "Books",
    module: "Study Materials",
    page: "Create",
    path: "studyMaterials/Books/CreateBookSet",
    element: <CreateBookSet />,
    order: "2",
    disable: false,
  },
  {
    id: "5",
    mid: "A",
    module: "Study Materials",
    subpage: "Books",
    page: "View",
    path: "studyMaterials/Books/ViewBookSet/:bookID/:ID",
    element: <ViewBookSet />,
    order: "3",
    disable: false,
  },
  {
    id: "6",
    mid: "A",
    module: "Study Materials",
    subpage: "Books",
    page: "Edit",
    path: "studyMaterials/Books/CreateBookSet/:id",
    element: <CreateBookSet />,
    order: "4",
    disable: false,
  },
  {
    id: "4",
    mid: "A",
    module: "Study Materials",
    subpage: "Books",
    page: "Create",
    path: "studyMaterials/Books/CreatePreOrder",
    element: <CreatePreOrder />,
    order: "2",
    disable: false,
  },
  {
    id: "5",
    mid: "A",
    module: "Study Materials",
    subpage: "Books",
    page: "View",
    path: "studyMaterials/Books/ViewPreOrder/:bookID/:ID",
    element: <ViewPreOrder />,
    order: "3",
    disable: false,
  },
  {
    id: "6",
    mid: "A",
    module: "Study Materials",
    subpage: "Books",
    page: "Edit Pre-Orders",
    path: "studyMaterials/Books/EditPreOrder/:book_id/:id",
    element: <EditPreOrder />,
    order: "4",
    disable: false,
  },
  {
    id: "13",
    mid: "Q",
    module: "Study Materials",
    subpage: "Review",
    page: "Review List",
    path: "studyMaterials/Books/Reviews",
    element: <ListReview />,
    order: "1",
    disable: false,
  },
  {
    id: "14",
    mid: "Q",
    module: "Study Materials",
    subpage: "Review",
    page: "View Review",
    path: "studyMaterials/Books/Reviews/View/:id",
    element: <ViewReview />,
    order: "3",
    disable: false,
  },
  {
    id: "15",
    mid: "Q",
    module: "Study Materials",
    subpage: "Review",
    page: "Edit Review",
    path: "studyMaterials/Books/Reviews/Edit/:id",
    element: <EditReview />,
    order: "4",
    disable: false,
  },
  {
    id: "16",
    mid: "R",
    module: "Study Materials",
    subpage: "Sales",
    page: "Sales List",
    path: "ListPurchase",
    element: <ListPurchase />,
    order: "1",
    disable: false,
  },
  {
    id: "17",
    mid: "R",
    module: "Study Materials",
    subpage: "Sales",
    page: "Create New Sales",
    path: "AddPurchase",
    element: <PurchsaeInfoCreate />,
    order: "2",
    disable: false,
  },
  {
    id: "18",
    mid: "R",
    module: "Study Materials",
    subpage: "Sales",
    page: "View Sales",
    path: "ViewPurchase/:id",
    element: <ViewPurchase />,
    order: "3",
    disable: false,
  },
  {
    id: "19",
    mid: "S",
    module: "Study Materials",
    subpage: "Courier Charges",
    page: "Add New Courier Details",
    path: "AddNewCourierDetails",
    element: <AddNewCourierDetails />,
    order: "2",
    disable: false,
  },
  {
    id: "20",
    mid: "S",
    module: "Study Materials",
    subpage: "Courier Charges",
    page: "View Courier Details",
    path: "ViewCourierDetails/:id",
    element: <ViewCourierDetails />,
    order: "3",
    disable: false,
  },
  {
    id: "19",
    mid: "S",
    module: "Study Materials",
    subpage: "Courier Charges",
    page: "Edit Courier Details",
    path: "EditCourierDetails/:id",
    element: <AddNewCourierDetails />,
    order: "4",
    disable: false,
  },
  {
    id: "22",
    mid: "S",
    module: "Study Materials",
    subpage: "Courier Charges",
    page: "Courier Charges List",
    path: "CourierCharges",
    element: <ListCouierCharges />,
    order: "1",
    disable: false,
  },
  {
    id: "23",
    mid: "S",
    module: "Study Materials",
    subpage: "Courier Charges",
    page: "Create New Courier Charges",
    path: "CreateCourierCharges",
    element: <CreateCourierCharges />,
    order: "2",
    disable: false,
  },
  {
    id: "24",
    mid: "S",
    module: "Study Materials",
    subpage: "Courier Charges",
    page: "View Courier Charge",
    path: "ViewCourierCharges/:id",
    element: <ViewCouierCharges />,
    order: "3",
    disable: false,
  },
  {
    id: "25",
    mid: "S",
    module: "Study Materials",
    subpage: "Courier Charges",
    page: "Edit Courier Charge",
    path: "EditCourierCharges/:id",
    element: <EditCourierCharges />,
    order: "4",
  },
  {
    id: "26",
    mid: "T",
    module: "Study Materials",
    subpage: "Reward Points",
    page: "Reward Points List",
    path: "RewardPoints",
    element: <ListRewardPoints />,
    order: "1",
    disable: false,
  },
  {
    id: "27",
    mid: "T",
    module: "Study Materials",
    subpage: "Reward Points",
    page: "Create New Reward Point",
    path: "CreateRewardPoints",
    element: <CreateRewardPoints />,
    order: "2",
    disable: false,
  },
  {
    id: "28",
    mid: "T",
    module: "Study Materials",
    subpage: "Reward Points",
    page: "View Reward Point",
    path: "ViewRewardPoints/:id/",
    element: <ViewRewardPoints />,
    order: "3",
    disable: false,
  },
  {
    id: "29",
    mid: "T",
    module: "Study Materials",
    subpage: "Reward Points",
    page: "Edit Reward Point",
    path: "CreateRewardPoints/:id",
    element: <CreateRewardPoints />,
    order: "4",
    disable: false,
  },
  // Coupon Code
  {
    id: "30",
    mid: "B",
    module: "Coupon Code",
    page: "Coupon Code List",
    path: "ListCouponCode",
    element: <ListCouponCode />,
    order: "1",
    disable: false,
  },
  {
    id: "31",
    mid: "B",
    module: "Coupon Code",
    page: "Create New Coupon Codes",
    path: "AddCoupon",
    element: <CouponInfoCreate />,
    order: "2",
    disable: false,
  },
  {
    id: "32",
    mid: "B",
    module: "Coupon Code",
    page: "View Coupon Code",
    path: "ViewCouponCode/:id",
    element: <ViewCouponCode />,
    order: "3",
    disable: false,
  },
  {
    id: "33",
    mid: "B",
    module: "Coupon Code",
    page: "Edit Coupon Code",
    path: "editCoupon/:id",
    element: <CouponInfoCreate />,
    order: "4",
    disable: false,
  },
  // Course Management
  {
    id: "34",
    mid: "C",
    module: "Course Management",
    page: "List",
    path: "CourseManagement",
    element: <CourseManagement />,
    order: "1",
    disable: false,
  },
  {
    id: "34",
    mid: "C",
    module: "Course Management",
    page: "List",
    path: "CourseManagement/:active_tab",
    element: <CourseManagement />,
    order: "1",
    disable: false,
  },
  {
    id: "35",
    mid: "C",
    module: "Course Management",
    page: "Create",
    path: "AddCourse",
    element: <CourseInfoCreate />,
    order: "2",
    disable: false,
  },
  {
    id: "36",
    mid: "C",
    module: "Course Management",
    page: "View",
    path: "ViewCourse/:id",
    element: <ViewCourseInfo />,
    order: "3",
    disable: false,
  },
  {
    id: "37",
    mid: "C",
    module: "Course Management",
    page: "Edit",
    path: "editCourse/:id",
    element: <CourseInfoCreate />,
    order: "4",
    disable: false,
  },
  {
    id: "35",
    mid: "C",
    module: "Course Management",
    page: "Create",
    path: "AddSubject",
    element: <SubjectInfoCreate />,
    order: "2",
    disable: false,
  },
  {
    id: "36",
    mid: "C",
    module: "Course Management",
    page: "View",
    path: "ViewSubject/:id/:opType",
    element: <ViewSubjectInfo />,
    order: "3",
    disable: false,
  },
  {
    id: "37",
    mid: "C",
    module: "Course Management",
    page: "Edit",
    path: "editSubject/:id/:opType",
    element: <SubjectInfoCreate />,
    order: "4",
    disable: false,
  },
  {
    id: "37",
    mid: "C",
    module: "Course Management",
    page: "Edit Subject",
    path: "AddSubject/:id",
    element: <SubjectInfoCreate />,
    order: "4",
    disable: false,
  },
  {
    id: "35",
    mid: "C",
    module: "Course Management",
    page: "Create",
    path: "AddTestTopic",
    element: <TestTopicInfoCreate />,
    order: "2",
    disable: false,
  },
  {
    id: "36",
    mid: "C",
    module: "Course Management",
    page: "View",
    path: "ViewTestTopic/:id",
    element: <ViewTestTopicInfo />,
    order: "3",
    disable: false,
  },
  {
    id: "37",
    mid: "C",
    module: "Course Management",
    page: "Edit",
    path: "AddTestTopic/:id",
    element: <TestTopicInfoCreate />,
    order: "4",
    disable: false,
  },
  // {
  //   id: "124",
  //   module: "Course Management",
  //   pages: "About Courses",
  //   path: "CourseContent/:name/:id",
  //   element: <CourseContent />,
  // },
  // Announcements
  {
    id: "44",
    mid: "D",
    module: "Announcements",
    page: "Announcements List",
    path: "Announcement",
    element: <ListAnnouncementInfo />,
    order: "1",
    disable: false,
  },
  {
    id: "45",
    mid: "D",
    module: "Announcements",
    page: "Create New Announcement",
    path: "CreateAnnouncement",
    element: <CreateAnnouncementInfo />,
    order: "2",
    disable: false,
  },
  {
    id: "46",
    mid: "D",
    module: "Announcements",
    page: "View Announcement",
    path: "ViewAnnouncement/:id",
    element: <ViewAnnouncementInfo />,
    order: "3",
    disable: false,
  },
  {
    id: "47",
    mid: "D",
    module: "Announcements",
    page: "Edit Announcement",
    path: "CreateAnnouncement/:id",
    element: <CreateAnnouncementInfo />,
    order: "4",
    disable: false,
  },
  // Gallery
  {
    id: "49",
    mid: "E",
    module: "Gallery",
    page: "Images List",
    path: "GalleryImages",
    element: <GridImageAdminInfo />,
    order: "1",
    disable: false,
  },
  {
    id: "49",
    mid: "E",
    module: "Gallery",
    page: "Images List",
    path: "/ViewImages/:id",
    element: <ViewImageAdminInfo />,
    order: "1",
    disable: false,
  },
  {
    id: "50",
    mid: "E",
    module: "Gallery",
    page: "Add New Image",
    path: "AddImageAdmin",
    element: <AddImageAdminInfo />,
    order: "2",
    disable: false,
  },
  {
    id: "51",
    mid: "E",
    module: "Gallery",
    page: "View Image",
    path: "ViewImages/:id",
    element: <ViewImageAdminInfo />,
    order: "3",
    disable: false,
  },
  {
    id: "52",
    mid: "E",
    module: "Gallery",
    page: "Edit Image",
    path: "EditImage/:id",
    element: <AddImageAdminInfo />,
    order: "4",
    disable: false,
  },
  {
    id: "53",
    mid: "E",
    module: "Gallery",
    page: "Add New Folder",
    path: "AddFolderAdmin/:type",
    element: <AddFolderAdminInfo />,
    order: "2",
    disable: false,
  },
  {
    id: "54",
    mid: "E",
    module: "Gallery",
    page: "Edit Folder",
    path: "EditFolder/:id/:type",
    element: <AddFolderAdminInfo />,
    order: "4",
    disable: false,
  },
  {
    id: "55",
    mid: "E",
    module: "Gallery",
    page: "Videos List",
    path: "GalleryVideos",
    element: <GridVideoAdminInfo />,
    order: "1",
    disable: false,
  },
  {
    id: "55",
    mid: "E",
    module: "Gallery",
    page: "Videos List",
    path: "/ViewVideos/:id",
    element: <ViewVideoAdminInfo />,
    order: "1",
    disable: false,
  },
  {
    id: "56",
    mid: "E",
    module: "Gallery",
    page: "Add New Video",
    path: "AddVideoAdmin",
    element: <AddVideoAdminInfo />,
    order: "2",
    disable: false,
  },
  {
    id: "57",
    mid: "E",
    module: "Gallery",
    page: "View Videos",
    path: "ViewVideos/:id",
    element: <ViewVideoAdminInfo />,
    order: "3",
    disable: false,
  },
  {
    id: "58",
    mid: "E",
    module: "Gallery",
    page: "Edit Video",
    path: "EditVideo/:id/:folderId",
    element: <AddVideoAdminInfo />,
    order: "4",
    disable: false,
  },
  {
    id: "59",
    mid: "E",
    module: "Gallery",
    page: "Slides List",
    path: "ViewBannerAdmin",
    element: <ViewBannerAdminInfo />,
    order: "1",
    disable: false,
  },
  {
    id: "60",
    mid: "E",
    module: "Gallery",
    page: "Add New Slide",
    path: "AddBanner",
    element: <AddBannerAdminInfo />,
    order: "2",
    disable: false,
  },
  {
    id: "61",
    mid: "E",
    module: "Gallery",
    page: "Edit Slide",
    path: "EditBanner/:id",
    element: <AddBannerAdminInfo />,
    order: "4",
    disable: false,
  },
  // Batch
  {
    id: "62",
    mid: "F",
    module: "Batch",
    page: "Batch List",
    path: "ViewCourseBatch",
    element: <ListviewBatch />,
    order: "1",
    disable: false,
  },
  {
    id: "62",
    mid: "F",
    module: "Batch",
    page: "Batch List",
    path: "ViewCourseBatch/:active_tab",
    element: <ListviewBatch />,
    order: "1",
    disable: false,
  },
  {
    id: "63",
    mid: "F",
    module: "Batch",
    page: "Create New Batch",
    path: "CreateCourseBatch/:Type",
    element: <CreateCourseBatch />,
    order: "2",
    disable: false,
  },
  {
    id: "64",
    mid: "F",
    module: "Batch",
    page: "View Batch",
    path: "DetailViewBatch/:id/:type",
    element: <ReadViewBath />,
    order: "3",
    disable: false,
  },
  {
    id: "131",
    mid: "F",
    module: "Batch",
    page: "Batch Students List - View",
    path: "DetailViewBatch/:id/:type",
    element: <ReadViewBath />,
    order: "3",
    disable: false,
  },
  {
    id: "64",
    mid: "F",
    module: "Batch",
    page: "View Batch",
    path: "TransactionHistory/ViewAdmission/:user_id/:batch_id/:add_id/:type/:label",
    element: <ReadViewAdmissionHistory />,
    order: "3",
    disable: false,
  },
  {
    id: "64",
    mid: "F",
    module: "Batch",
    page: "View Batch",
    path: "TransactionHistory/ViewAdmission/ViewPaymentHistory/:type/:adm_id",
    element: <PaymentHistory />,
    order: "3",
    disable: false,
  },
  {
    id: "64",
    mid: "F",
    module: "Batch",
    page: "View",
    path: "TransactionHistory/ViewAdmission/ViewSchedule/:batch_id/:type",
    element: <ReadViewBath />,
    order: "3",
    disable: false,
  },
  {
    id: "65",
    mid: "F",
    module: "Batch",
    page: "Model Exam - View Model Exam",
    path: "DetailViewBatch/:id/:type",
    element: <ReadViewBath />,
    order: "3",
    disable: false,
  },
  {
    id: "66",
    mid: "F",
    module: "Batch",
    page: "Edit Batch",
    path: "CreateCourseBatch/:Type/:id",
    element: <CreateCourseBatch />,
    order: "4",
    disable: false,
  },
  {
    id: "67",
    mid: "F",
    module: "Batch",
    page: "Model Exam - Exam Centres - View",
    path: "exam_centre",
    element: <ExamCentreByDistrict />,
    order: "5",
    disable: false,
  },
  {
    id: "68",
    mid: "F",
    module: "Batch",
    page: "Model Exam - Model Exam Analytics",
    path: "ModelExamAnalytics/:type",
    element: <ModelExamAnalytics />,
    order: "6",
    disable: false,
  },
  {
    id: "69",
    mid: "F",
    module: "Batch",
    page: "Model Exam - View Model Exam Analytics",
    path: "viewmodelexamanalytics",
    element: <ViewModelExamAnalytics />,
    order: "7",
    disable: false,
  },
  {
    id: "70",
    mid: "F",
    module: "Batch",
    page: "Model Exam - Generate Report",
    path: "GenerateReport/:batch_id",
    element: <GenarateReportListView />,
    order: "8",
    disable: false,
  },
  {
    id: "70",
    mid: "F",
    module: "Batch",
    page: "Model Exam - Generate Report",
    path: "GenerateReport/:batch_id/:active_tab",
    element: <GenarateReportListView />,
    order: "9",
    disable: false,
  },
  {
    id: "71",
    mid: "F",
    module: "Batch",
    page: "Model Exam - Centre Supervisors - List",
    path: "CentreSupervisors/:batch_id",
    element: <CentreSupervisor />,
    order: "10",
    disable: false,
  },
  // Admission
  {
    id: "72",
    mid: "G",
    module: "Admission List",
    page: "List",
    path: "ListViewStudentConfirm",
    element: <Listview />,
    order: "1",
    disable: false,
  },
  {
    id: "73",
    mid: "G",
    module: "Admission List",
    page: "View",
    path: "studentConfirm/:userId/:admissId/:appliedOn/:type",
    element: <StudentConfirm />,
    order: "3",
    disable: false,
  },
  {
    id: "74",
    mid: "G",
    module: "Admission List",
    page: "Report Download (CSV / PDF)",
    path: "ListViewStudentConfirm",
    element: <Listview />,
    order: "4",
    disable: true,
  },
  {
    id: "72",
    mid: "G",
    module: "Admission List",
    page: "List",
    path: "ListViewStudentConfirm/:typeFilter",
    element: <Listview />,
    order: "4",
    disable: true,
  },
  // Event
  {
    id: "75",
    mid: "F",
    module: "Batch",
    page: "Create New Event",
    path: "CreateEvent",
    element: <CreateEvent />,
    order: "2",
    disable: false,
  },
  {
    id: "76",
    mid: "F",
    module: "Batch",
    page: "View Event",
    path: "AdminDetailCalendar",
    element: <DSchedule />,
    order: "3",
    disable: false,
  },
  {
    id: "77",
    mid: "F",
    module: "Batch",
    page: "Edit Event",
    path: "CreateEvent",
    element: <CreateEvent />,
    order: "4",
    disable: false,
  },
  // Test List
  {
    id: "78",
    mid: "H",
    module: "Test List",
    page: "Test Lists",
    path: "TestList",
    element: <TestListview />,
    order: "1",
    disable: false,
  },
  {
    id: "79",
    mid: "H",
    module: "Test List",
    page: "View Test",
    path: "/DetailTestView/:id/:status/:type",
    element: <DetailTestView />,
    order: "3",
    disable: false,
  },
  {
    id: "80",
    mid: "H",
    module: "Test List",
    page: "Upload Question Paper (O & D)",
    path: "UploadQuestionFile/:type",
    element: <UploadQuestionFile />,
    order: "4",
    disable: false,
  },
  {
    id: "79",
    mid: "H",
    module: "Test List",
    page: "Upload Answer Sheet",
    path: "UploadAnswerSheet",
    element: <UploadAnswerSheet />,
    order: "5",
    disable: false,
  },
  {
    id: "79",
    mid: "H",
    module: "Test List",
    page: "View Answer Sheet",
    path: "ViewAnswerSheet/:id",
    element: <AdminViewAnswerSheet />,
    order: "5",
    disable: false,
  },
  {
    id: "79",
    mid: "H",
    module: "Test List",
    page: "Edit Answer Sheet",
    path: "UploadAnswerSheet/:id",
    element: <UploadAnswerSheet />,
    order: "5",
    disable: false,
  },
  {
    id: "79",
    mid: "H",
    module: "Test List",
    page: "View Test",
    path: "ViewTestList",
    element: <ViewTestList />,
    order: "5",
    disable: false,
  },
  {
    id: "81",
    mid: "H",
    module: "Test List",
    page: "Top Performer Answer Sheet",
    path: "TopPerfomanceAnswerSheet",
    element: <TopPerfomanceAnswerSheet />,
    order: "6",
    disable: false,
  },
  {
    id: "82",
    mid: "H",
    module: "Test List",
    page: "View Student",
    path: "ViewStudent",
    element: <ViewStudent />,
    order: "7",
    disable: false,
  },
  {
    id: "83",
    mid: "H",
    module: "Test List",
    page: "View Evaluator ",
    path: "ViewEvaluator",
    element: <ViewEvaluator />,
    order: "8",
    disable: false,
  },
  {
    id: "84",
    mid: "H",
    module: "Test List",
    page: "View Question Paper",
    path: "ViewQuestionPaper",
    element: <ViewQuestionPaper />,
    order: "9",
    disable: false,
  },
  // Register User
  {
    id: "125",
    mid: "I",
    module: "Registered Users",
    page: "Report Download (CSV / PDF)",
    path: "RegisteredUser",
    element: <UserList />,
    order: "4",
    disable: true,
  },
  {
    id: "85",
    mid: "I",
    module: "Registered Users",
    page: "User List",
    path: "RegisteredUser",
    element: <UserList />,
    order: "1",
    disable: false,
  },
  {
    id: "86",
    mid: "I",
    module: "Registered Users",
    page: "View User",
    path: "RegisterUser/ViewUser/:user_id",
    element: <ReviewUserDetail />,
    order: "3",
    disable: false,
  },
  // Faculties
  {
    id: "127",
    mid: "J",
    module: "Faculty",
    page: "Report Download (CSV / PDF)",
    path: "Faculties/:active_tab",
    element: <ListViewFaculty />,
    order: "5",
    disable: true,
  },
  {
    id: "127",
    mid: "J",
    module: "Faculty",
    page: "Report Download (CSV / PDF)",
    path: "Faculties",
    element: <ListViewFaculty />,
    order: "1",
    disable: true,
  },
  {
    id: "87",
    mid: "J",
    module: "Faculty",
    page: "Faculty List",
    path: "Faculties",
    element: <ListViewFaculty />,
    order: "1",
    disable: false,
  },
  {
    id: "87",
    mid: "J",
    module: "Faculty",
    page: "Faculty List",
    path: "Faculties/:active_tab",
    element: <ListViewFaculty />,
    order: "1",
    disable: false,
  },
  {
    id: "88",
    mid: "J",
    module: "Faculty",
    page: "Create New",
    path: "Faculties/addfaculty/:facId/:userId",
    element: <NewFaculty />,
    order: "2",
    disable: false,
  },
  {
    id: "88",
    mid: "J",
    module: "Faculty",
    page: "Upload Marksheet",
    path: "UploadMarkSheet",
    element: <UploadMarkSheet />,
    order: "3",
    disable: false,
  },
  {
    id: "88",
    mid: "J",
    module: "Faculty",
    page: "Create New",
    path: "Faculties/addfaculty/:facId",
    element: <NewFaculty />,
    order: "2",
    disable: false,
  },
  {
    id: "88",
    mid: "J",
    module: "Faculty",
    page: "Create New",
    path: "Faculties/AddPanelMember",
    element: <AddPanelMember />,
    order: "2",
    disable: false,
  },
  {
    id: "88",
    mid: "J",
    module: "Faculty",
    page: "Create New",
    path: "Faculties/AddPanelMember/:userId",
    element: <AddPanelMember />,
    order: "2",
    disable: false,
  },
  {
    id: "88",
    mid: "J",
    module: "Faculty",
    page: " Add New Salary",
    path: "Faculties/AddSalary/:userId/:staff_id/:staff_type/:amount",
    element: <AddSalary />,
    order: "2",
    disable: false,
  },
  {
    id: "89",
    mid: "J",
    module: "Faculty",
    page: "View",
    path: "readfaculty/:userId",
    element: <ReadFaculty />,
    order: "3",
    disable: false,
  },
  {
    id: "89",
    mid: "J",
    module: "Faculty",
    page: "Review Faculty Profile",
    path: "ReviewFacultyProfile/:userId",
    element: <ReviewFaculty />,
    order: "4",
    disable: false,
  },
  {
    id: "89",
    mid: "J",
    module: "Faculty",
    page: "View Faculty Profile",
    path: "Faculties/ReadViewPanelMember/:userId",
    element: <ReadViewPMem />,
    order: "3",
    disable: false,
  },
  {
    id: "89",
    mid: "J",
    module: "Faculty",
    page: "View Faculty Profile",
    path: "Faculties/FacultyDetailView/:userId/:staff_id",
    element: <FacultyDetailview />,
    order: "3",
    disable: false,
  },
  {
    id: "89",
    mid: "J",
    module: "Faculty",
    page: "View Faculty Profile",
    path: "Faculties/FacultyDetailView/:userId/:staff_id/:active_tab",
    element: <FacultyDetailview />,
    order: "3",
    disable: false,
  },
  {
    id: "89",
    mid: "J",
    module: "Faculty",
    page: "View Faculty Profile",
    path: "Faculties/FacultyDetailView/:userId/:staff_id/:active_tab/:type",
    element: <FacultyDetailview />,
    order: "3",
    disable: false,
  },
  {
    id: "89",
    mid: "J",
    module: "Faculty",
    page: "View Faculty Profile",
    path: "StaffDetailCalendar",
    element: <StaffDetailCalendar />,
    order: "3",
    disable: false,
  },

  {
    id: "89",
    mid: "J",
    module: "Faculty",
    page: "View Staff Profile",
    path: "Faculties/NonTeachingDetailView/:userId/:staff_id",
    element: <NonFDetailview />,
    order: "3",
    disable: false,
  },
  {
    id: "89",
    mid: "J",
    module: "Faculty",
    page: "View Staff Profile",
    path: "Faculties/NonTeachingDetailView/:userId/:staff_id/:active_tab",
    element: <NonFDetailview />,
    order: "3",
    disable: false,
  },
  {
    id: "89",
    mid: "J",
    module: "Faculty",
    page: "View Salary",
    path: "Faculties/ReadViewSalary/:userId/:id/:staff_id/:staff_type",
    element: <ReadViewSalary />,
    order: "3",
    disable: false,
  },
  {
    id: "88",
    mid: "J",
    module: "Faculty",
    page: "Add New",
    path: "Faculties/AddSalary/:staff_id/:userId",
    element: <AddSalary />,
    order: "2",
    disable: false,
  },
  {
    id: "89",
    mid: "J",
    module: "Faculty",
    page: "View Faculty Profile",
    path: "Faculties/PanelMember/:userId/:staff_id",
    element: <PanelMemberView />,
    order: "3",
    disable: false,
  },
  {
    id: "89",
    mid: "J",
    module: "Faculty",
    page: "View Faculty Profile",
    path: "Faculties/PanelMember/:userId/:staff_id/:active_tab",
    element: <PanelMemberView />,
    order: "3",
    disable: false,
  },
  {
    id: "89",
    mid: "J",
    module: "Faculty",
    page: "View Faculty Profile",
    path: "Faculties/PanelMember/:userId/:staff_id/:active_tab/:type",
    element: <PanelMemberView />,
    order: "3",
    disable: false,
  },
  {
    id: "89",
    mid: "J",
    module: "Faculty",
    page: "View Student",
    path: "AdminViewStudent/:path_id",
    element: <AdminViewStudent />,
    order: "3",
    disable: false,
  },
  {
    id: "89",
    mid: "J",
    module: "Faculty",
    page: "View Student",
    path: "/ReviewTeachingProgress",
    element: <ReviewTProgress />,
    order: "3",
    disable: false,
  },
  {
    id: "90",
    mid: "J",
    module: "Faculty",
    page: "Edit",
    path: "Faculties/AddSalary/:userId/:staff_id/:staff_type/:amount/:id",
    element: <AddSalary />,
    order: "4",
    disable: false,
  },
  // Model Exam
  {
    id: "91",
    mid: "K",
    module: "Exam Centers",
    page: "Center Supervisor - List ",
    path: "ModelExamCenter",
    element: <ModelExamCenter />,
    order: "1",
    disable: false,
  },
  {
    id: "92",
    mid: "K",
    module: "Exam Centers",
    page: "Center Supervisor - View",
    path: "ViewModelExam",
    element: <ViewModelExam />,
    order: "3",
    disable: false,
  },
  // Faculty profile
  {
    id: "93",
    mid: "L",
    module: "AdminAccess",
    page: "My Profile",
    path: "facultyProfile",
    element: <FacultyProfile />,
    order: "1",
    disable: false,
  },
  {
    id: "93",
    mid: "L",
    module: "AdminAccess",
    page: "My Profile",
    path: "facultyProfile/:userId",
    element: <FacultyProfile />,
    order: "1",
    disable: false,
  },
  {
    id: "93",
    mid: "L",
    module: "AdminAccess",
    page: "My Profile",
    path: "NonFacultyProfile",
    element: <NonFacultyProfile />,
    order: "1",
    disable: false,
  },
  {
    id: "93",
    mid: "L",
    module: "AdminAccess",
    page: "My Profile",
    path: "NonFacultyProfile/:userId",
    element: <NonFacultyProfile />,
    order: "1",
    disable: false,
  },
  {
    id: "94",
    mid: "L",
    module: "Faculty Profile",
    page: "View Faculty Profile",
    path: "ProfileFacultyView",
    element: <FaculityView />,
    order: "1",
    disable: false,
  },
  {
    id: "94",
    mid: "L",
    module: "Faculty Profile",
    page: "View Faculty Profile",
    path: "ProfileFacultyView/:active_tab",
    element: <FaculityView />,
    order: "1",
    disable: false,
  },
  {
    id: "94",
    mid: "J",
    module: "Faculty",
    page: "View Faculty Profile",
    path: "StaffDetailCalendar",
    element: <StaffDetailCalendar />,
    order: "1",
    disable: false,
  },
  {
    id: "94",
    mid: "J",
    module: "Faculty",
    page: "View Faculty Profile",
    path: "Faculties/ReadViewSalary/:userId/:id/:staff_id/:staff_type",
    element: <ReadViewSalary />,
    order: "1",
    disable: false,
  },
  {
    id: "94",
    mid: "J",
    module: "Faculty",
    page: "View Faculty Profile",
    path: "/ReviewTeachingProgress",
    element: <ReviewTProgress />,
    order: "1",
    disable: false,
  },
  // Student List
  {
    id: "95",
    mid: "M",
    module: "Student List",
    page: "Evaluator - Students List",
    path: "StudentsList",
    element: <StudentsList />,
    order: "1",
    disable: false,
  },
  {
    id: "96",
    mid: "M",
    module: "Student List",
    page: "Evaluator - View Student",
    path: "ViewStudent",
    element: <ViewStudent />,
    order: "2",
    disable: false,
  },
  {
    id: "97",
    mid: "M",
    module: "Student List",
    page: "Evaluator - Update Marks",
    path: "UpdateMarks",
    element: <UpdateMarks />,
    order: "3",
    disable: false,
  },
  // Students Query
  {
    id: "98",
    mid: "N",
    module: "Students Query",
    page: "Query List",
    path: "StudentsQuery",
    element: <StudentsQuery />,
    order: "1",
    disable: false,
  },
  {
    id: "99",
    mid: "N",
    module: "Students Query",
    page: "View Query",
    path: "Query",
    element: <ViewStudentQuery />,
    order: "2",
    disable: false,
  },
  // Cash Payments
  {
    id: "100",
    mid: "O",
    module: "Cash Payments",
    page: "List",
    path: "CashPayment",
    element: <CashListView />,
    order: "1",
    disable: false,
  },
  {
    id: "100",
    mid: "O",
    module: "Cash Payments",
    page: "List",
    path: "CashPayment/:active_tab",
    element: <CashListView />,
    order: "1",
    disable: false,
  },
  {
    id: "101",
    mid: "O",
    module: "Cash Payments",
    page: "View",
    path: "CashPayment/payFee",
    element: <CashPayFee />,
    order: "2",
    disable: false,
  },
  {
    id: "123",
    module: "AdminAccess",
    page: "",
    path: "roleList",
    element: <RoleList />,
  },
  {
    id: "123",
    module: "AdminAccess",
    page: "",
    path: "MenuList/:user_id",
    element: <MenuList />,
  },
  {
    id: "123",
    module: "AdminAccess",
    page: "",
    path: "viewRole/:id",
    element: <ViewRole />,
  },
  {
    id: "123",
    module: "AdminAccess",
    page: "Edit Page",
    path: "EditPageAccess/:user_id",
    element: <EditPage />,
  },
  {
    id: "123",
    module: "AdminAccess",
    pages: "Course Content",
    path: "CourseContent/:name/:id",
    element: <CourseContent />,
  },
  {
    id: "126",
    module: "AdminAccess",
    index: true,
    element: <IndexPage />,
  },
  {
    id: "128",
    mid: "P",
    module: "Class List",
    page: "Class List",
    path: "/ClassList",
    order: "1",
    element: <ClassList />,
  },
  {
    id: "128",
    mid: "P",
    module: "Class List",
    page: "Class List",
    path: "/ClassList/:index",
    order: "1",
    element: <ClassList />,
  },
  {
    id: "129",
    mid: "P",
    module: "Class List",
    page: "View Class",
    path: "/DetailTestView/:id/:status/:type",
    order: "1",
    element: <DetailTestView />,
  },
  {
    id: "130",
    module: "AdminAccess",
    path: "/AdmissionTermsAndCondition",
    element: <TermsCondition />,
  },
  {
    id: "130",
    module: "AdminAccess",
    path: "/BooksTermsAndCondition",
    element: <TermsConditionBook />,
  },
  {
    id: "130",
    module: "AdminAccess",
    path: "/ShippingPolicy",
    element: <ShippingPolicy />,
  },
  {
    id: "130",
    module: "AdminAccess",
    path: "/RefundAndCancellationPolicy",
    element: <RefundPolicy />,
  },
  {
    id: "130",
    module: "AdminAccess",
    path: "/ContactUs",
    element: <ContactUs />,
  },
  {
    id: "130",
    module: "AdminAccess",
    path: "/AdmissionPrivacyPolicy",
    element: <PrivacyPolicy />,
  },
  {
    id: "130",
    module: "AdminAccess",
    path: "/AdmissionPrivacyPolicy",
    element: <PrivacyPolicy />,
  },
  {
    id: "130",
    module: "AdminAccess",
    path: "/WhoWeAre",
    element: <WhoWeAre />,
  },
  {
    id: "130",
    module: "AdminAccess",
    path: "/WhyChooseUs",
    element: <WhyChooseUs />,
  },
  {
    id: "140",
    mid: "Z",
    module: "Interview List",
    path: "/ListInterviewDetails/:batch_id",
    element: <ListInterviewDetails />,
  },
  {
    id: "140",
    mid: "Z",
    module: "Interview List",
    path: "/ViewInterviewDetails/:batch_id/:id",
    element: <ViewInterviewDetails />,
  },
  {
    id: "140",
    mid: "Z",
    module: "Interview List",
    path: "/PanelInfoCreate",
    element: <PanelInfoCreate />,
  },
  {
    id: "140",
    mid: "Z",
    module: "Interview List",
    path: "/PanelInfoCreate/:id",
    element: <PanelInfoCreate />,
  },
  {
    id: "134",
    mid: "U",
    module: "Panel List",
    page: "Panel List",
    path: "/Panellist",
    order: "1",
    element: <ListPanelInfo />,
  },
  {
    id: "135",
    mid: "V",
    module: "Panel List",
    page: "View Panel",
    path: "/Viewpanel",
    order: "2",
    element: <ViewPanelInfo />,
  },
  {
    id: "135",
    mid: "U",
    module: "Panel List",
    page: "View Panel",
    path: "/Viewpanel/:id",
    order: "2",
    element: <ViewPanelInfo />,
  },
  {
    id: "136",
    mid: "W",
    module: "Panel List",
    page: "View Interview Perfomance",
    path: "/ViewInterviewPerfomance",
    order: "3",
    element: <ViewInterviewPerfomance />,
  },
  {
    id: "137",
    mid: "X",
    module: "Panel List",
    page: "View Student",
    path: "/ViewStudentDetails/:studentId",
    order: "4",
    element: <ViewStudentDetails />,
  },

  {
    id: "138",
    mid: "Y",
    module: "Panel List",
    page: "Update Marks",
    path: "/MockInterviewMarksUpdate",
    order: "5",
    element: <MockInterviewMarksUpdate />,
  },
  {
    id: "139",
    mid: "Z",
    module: "Interview List",
    page: "Interview List",
    path: "/Interviewlist",
    order: "1",
    element: <ListInterviewDetails />,
  },
  {
    id: "140",
    mid: "Z",
    module: "Interview List",
    page: "View Interview",
    path: "/ViewInterviewDetails/:id",
    order: "2",
    element: <ViewInterviewDetails />,
  },
  {
    id: "140",
    mid: "Z",
    module: "Interview List",
    page: "Interview Feedback",
    path: "/InterviewFeedbackList",
    order: "",
    element: <InterviewFeedBackList />,
  },
];
